export default function AboutSection() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Text Content */}
          <div>
            <span className="text-xs font-semibold text-primary-600 uppercase tracking-wider mb-3 block">
              Über OOPBuy Spreadsheet
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-6 leading-tight">
              Das größte deutsche Fashion Spreadsheet für China-Imports
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                <strong className="text-foreground-950">OOPBuy Spreadsheet</strong> ist dein ultimativer Begleiter beim Fashion-Shopping aus China.
                Unsere kuratierte Sammlung umfasst über 3.000 hochwertige Funde von verifizierten Verkäufern
                – organisiert in übersichtliche Kategorien wie Schuhe, Kleidung, Taschen, Accessoires und mehr.
              </p>
              <p>
                Was macht unser OOPBuy Spreadsheet zum <strong className="text-foreground-950">besten Shopping-Tool</strong>?
                Wir aktualisieren es täglich mit den neuesten OOPBuy-Funden und besten Produkten.
                Jedes Item wird von unserem Team geprüft, damit du ausschließlich
                <a href="/article/was-ist-oopbuy-spreadsheet" className="text-primary-600 hover:text-primary-700 underline">hochwertige OOPBuy Funde</a>{' '}
                von verifizierten und <strong>OOPBuy trusted sellers</strong> siehst.
              </p>
              <p>
                Stöbere nach Kategorie:{' '}
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-primary-600 hover:text-primary-700 underline">Sneaker</a>,{' '}
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-primary-600 hover:text-primary-700 underline">Clothing</a>,{' '}
                <a href="https://kaspreadsheet.com/search-921/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-primary-600 hover:text-primary-700 underline">Bags</a>,{' '}
                <a href="https://kaspreadsheet.com/search-920/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-primary-600 hover:text-primary-700 underline">Accessoires</a>{' '}
                und mehr. Oder entdecke unsere{' '}
                <a href="/article/was-ist-oopbuy-spreadsheet" className="text-primary-600 hover:text-primary-700 underline">OOPBuy Anleitung</a>{' '}
                für Einsteiger.
              </p>
            </div>
          </div>

          {/* Images */}
          <div className="grid grid-cols-2 gap-4">
            <div className="rounded-2xl overflow-hidden aspect-[3/4]">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20fashion%20photography%20studio%20workspace%20with%20mood%20board%20covered%20wall%20and%20clothing%20rack%20featuring%20curated%20outfit%20selections%2C%20creative%20atmosphere%20with%20warm%20ambient%20track%20lighting%2C%20artistic%20loft%20interior%20with%20exposed%20brick%20and%20plants%2C%20editorial%20behind%20the%20scenes%20aesthetic&width=600&height=800&seq=about-img-v2-01&orientation=portrait"
                alt="OOPBuy Spreadsheet Fashion Studio"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="rounded-2xl overflow-hidden aspect-[3/4] mt-8">
              <img
                src="https://readdy.ai/api/search-image?query=Detailed%20closeup%20of%20fashion%20product%20being%20photographed%20on%20white%20surface%20with%20professional%20camera%20equipment%20visible%20in%20soft%20blur%2C%20quality%20product%20photography%20scene%2C%20bright%20clean%20studio%20lighting%2C%20organized%20creative%20workspace%20with%20color%20swatches%20nearby%2C%20warm%20neutral%20tones&width=600&height=800&seq=about-img-v2-02&orientation=portrait"
                alt="OOPBuy Product Photography"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}